<template>
  <div v-if="loading_page"></div>
  <div v-else id="invoice-POS">
    <center id="top" style="margin-bottom: 10px;">
      <!-- <div class="logo">
        <img :src="img_arin" alt="" style="max-width: 120px;">
      </div> -->
      <div class="info w-100" style="margin-bottom: 10px;">
        <div class="font-10"> {{ seller.status_main_store == 1 ? 'บริษัท ฟาร์มาแคร์ พลัส จำกัด' : seller.store_name }}
        </div>
        <div class="font-10">TAX#{{ seller.store_personal_id }} (VAT Includ)</div>
        <div class="font-10">{{ seller.address }} {{ seller.address_list }}</div>
        <!-- <div class="font-10">ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ</div> -->
        <div class="font-10">POS ID - </div>
        <!-- <div class="font-10">เบอร์โทร {{ seller.tel }}</div> -->
       
      </div><!--End Info-->
    </center>
    <!--End InvoiceTop-->
    <!-- <br /> -->

    <center id="top">
      <div class="info w-100" style="margin-bottom: 10px;">
        <div class="font-13 fw-500">รหัสเครื่อง -</div>
        <div class="font-13 fw-500">เลขที่เอกสาร {{ seller.customer_code }}</div>
        <div class="font-13 fw-500">วันที่ {{ formatDate(get_data.created_at) }} </div>
        <!-- {{ get_data }} -->
        <!-- <div class="font-13">ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ</div> -->
        <div class="font-13 fw-500">แคชเชียร์ {{ get_data.user_edit }}</div>
        <!-- <div class="font-13">เบอร์โทร {{ seller.tel }}</div> -->
      </div><!--End Info-->
    </center>
    <!--End InvoiceTop-->

    <v-row style="margin-top: 2px !important;">
      <v-col cols="6">
        <div class="font-13 fw-500">SIGN-IN {{ formatTime(get_data.created_at) }} </div>
      </v-col>
      <v-col cols="6">
        <div class="font-13 fw-500 text-right">SIGN-OUT {{ formatTime(get_data.updated_at) }} </div>
      </v-col>
    </v-row>
    <div id="bot">
      <div id="table">
        <table>
          <tr>
            <td>
              <h1 class="font-13 fw-600" style="margin-left: 13px;">สรุปยอดขาย :</h1>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">ยอดขาย</p>
            </td>
            <td></td>
            <td>
              <!-- <p class="mt-5 font-12">{{total_qty}} ชิ้น</p> -->
            </td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ formatPrice(get_data.total_amount) }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">ส่วนลด</p>
            </td>
            <td></td>
            <td>
              <p class="mt-5 font-10"></p>
            </td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ formatPrice(get_data.discount) }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">ยอดขายหักส่วนลด</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ formatPrice(get_data.total_amount_after_discount) }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">ภาษี 7%</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ formatPrice(get_data.vat) }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">ยอดขายสุทธิ</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ formatPrice(get_data.total_amount_after_vat) }}</p>
            </td>
          </tr>

          <tr>
            <td colspan="4">
              <div class="color-gray font-11"> - - - - - - - - - - - - - - - - - - - - - - - - - -</div>
            </td>
          </tr>

          <tr>
            <td colspan="4">
              <h1 class="font-13 fw-600" style="margin-left: 13px;">สรุปการรับเงิน / การขาย :</h1>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">เงินสด</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ formatPrice(get_data.new_cash) }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">เงินโอน</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ formatPrice(get_data.payment) }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">qr payment</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ formatPrice(get_data.qrcode_pay) }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">เครดิตการ์ด</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ formatPrice(get_data.credit) }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">อื่นๆ</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ formatPrice(get_data.etc_payment) }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">แต้มแทนเงินสด</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ formatPrice(get_data.use_point) }}</p>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <hr style="border-top: #D9D9D9; margin: 5px 0;" />
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">รวมรับเงินทั้งสิ้น</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ formatPrice(get_data.total_amount_after_vat) }}</p>
            </td>
          </tr>

          <tr>
            <td colspan="4">
              <div class="color-gray font-11"> - - - - - - - - - - - - - - - - - - - - - - - - - -</div>
            </td>
          </tr>

          <tr>
            <td colspan="4">
              <h1 class="font-13 fw-600" style="margin-left: 13px;">สรุปการรับเงิน / เครดิตการ์ด :</h1>
            </td>
          </tr>

          <tr v-for="(item, i) in get_data.credit_card" :key="i" class="tabletitle">
            <td>
              <p class="mt-5 font-10">{{item.card_name_eng}}</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{formatPrice(item.total)}}</p>
            </td>
          </tr>

          <!-- <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">KTB</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">1,593.50</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">KTB</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">1,593.50</p>
            </td>
          </tr> -->

          <tr>
            <td colspan="4">
              <hr style="border-top: #D9D9D9; margin: 5px 0;" />
            </td>
          </tr>
          <tr class="tabletitle">
            <td colspan="3"> 
              <p class="mt-5 font-10">Credit Charge</p>
            </td>
            
            <td colspan="" class="text-right">
              <p class="mt-5 font-10">{{ formatPrice(get_data.credit_charge) }}</p>
            </td>
          </tr>


          <tr>
            <td colspan="4">
              <div class="color-gray font-11"> - - - - - - - - - - - - - - - - - - - - - - - - - -</div>
            </td>
          </tr>

          <tr>
            <td colspan="4">
              <h1 class="font-13 fw-600" style="margin-left: 13px;">สรุปยอดเงินสดในลิ้นชัก :</h1>
            </td>
          </tr>

          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">เงินทอน</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ formatPrice(get_data.init_money_amount) }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">รับจากการขาย</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ formatPrice(get_data.total_cash) }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">ส่วนต่าง ณ ตอนปิดรอบ</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ formatPrice(get_data.diff_total_cash) }}</p>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <hr style="border-top: #D9D9D9; margin: 5px 0;" />
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">เงินคงเหลือในลิ้นชัก</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ formatPrice(get_data.total_cash_net) }}</p>
            </td>
          </tr>

          <!-- <tr>
            <td colspan="4">
              <div class="color-gray font-11"> - - - - - - - - - - - - - - - - - - - - - - - - - -</div>
            </td>
          </tr>
          <h1 class="font-13 fw-600" style="margin-left: 13px;">สรุปยอดส่งเงิน :</h1>

          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">เงินสด</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">1,593.50</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">เครดิตการ์ด</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">0.00</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">คูปอง</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">0.00</p>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <hr style="border-top: #D9D9D9; margin: 5px 0;" />
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">รวมมูลค่านำส่ง</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">0.00</p>
            </td>
          </tr> -->

          <!-- <tr>
            <td colspan="4">
              <div class="color-gray font-11"> - - - - - - - - - - - - - - - - - - - - - - - - - -</div>
            </td>
          </tr>
          <h1 class="font-13 fw-600" style="margin-left: 13px;">สรุปยอดเงินคงเหลือในลิ้นชัก :</h1>

          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">เงินสด</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">1,593.50</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">เครดิตการ์ด</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">0.00</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">คูปอง</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">0.00</p>
            </td>
          </tr> -->

          <tr>
            <td colspan="4">
              <div class="color-gray font-11"> - - - - - - - - - - - - - - - - - - - - - - - - - -</div>
            </td>
          </tr>

          <!-- <tr>
            <td>
              <h1 class="font-13 fw-600" style="margin-left: 13px;">เลขที่ใบเสร็จ :</h1>
            </td>
          </tr>

          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">เลขที่ใบเสร็จเริ่มต้น</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ get_data.first_invoice }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">เลขที่ใบเสร็จสุดท้าย</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ get_data.last_invoice }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">จำนวนบิลขายทั้งหมด</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ get_data.count_bill }}</p>
            </td>
          </tr> -->
          <!-- <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">จำนวนบิลขายสด</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">0.00</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">จำนวนบิลขายเชื่อ</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">0.00</p>
            </td>
          </tr> -->

          <!-- <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">เฉลี่ยขายต่อบิล</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ formatPrice(get_data.avg_total) }}</p>
            </td>
          </tr> -->

          <!-- <tr>
            <td colspan="4">
              <hr style="border-top: #D9D9D9; margin: 5px 0;" />
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">เลขที่ใบรับคืนเริ่มต้น</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">0.00</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">เลขที่ใบรับคืนสุดท้าย</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">0.00</p>
            </td>
          </tr> -->
          <!-- <tr>
            <td colspan="4">
              <div class="color-gray font-11"> - - - - - - - - - - - - - - - - - - - - - - - - - -</div>
            </td>
          </tr> -->


          <!-- <tr>
            <td colspan="4">
              <div class=" font-10 "> ข้อมูลสมาชิก {{ detailList.invoice.member_name }} </div>
            </td>
          </tr>
          <br>
          <tr>
            <td class="item"></td>
            <td>
              <p class="font-10 text-center">ได้รับ</p>
            </td>
            <td>
              <p class="font-10 text-center">ใช้ไป</p>
            </td>
            <td>
              <p class="font-10 text-center">คงเหลือ</p>
            </td>
          </tr>

          <tr>
            <td>
              <p class="font-10 mt-5">แต้มสมาชิก</p>
            </td>
            <td>
              <p class="font-10 text-center mt-5">+{{ detailList.invoice.member_name == null ? formatPrice(0) :
                formatPrice(detailList.invoice.point) }}</p>
            </td>
            <td>
              <p class="font-10 text-center mt-5">{{ formatPrice(detailList.invoice.use_point) }}</p>
            </td>
            <td>
              <p class="font-10 text-center mt-5">{{ formatPrice(detailList.invoice.point_remain) }}</p>
            </td>
          </tr>

          <tr>
            <td colspan="4">
              <div class="color-gray-mid font-10 mt-4 "> ** ยอดใช้ไปและยอดคงเหลือ ไม่รวมยอดสะสมครั้งนี้ ** </div>
            </td>
          </tr> -->

          <tr>
            <td colspan="4">
              <h1 class="font-13 fw-600" style="margin-left: 13px;">สรุปการรับเงินจากการขาย / ไม่มีภาษี :</h1>
            </td>
          </tr>

          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">เงินสด</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ total_sum.total_cash }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">เงินโอน</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ total_sum.total_payment }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">qr payment</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ total_sum.total_qr }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">เครดิตการ์ด</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ total_sum.total_credit }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">อื่นๆ</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ total_sum.total_etc }}</p>
            </td>
          </tr>

          <tr>
            <td colspan="4">
              <hr style="border-top: #D9D9D9; margin: 5px 0;" />
            </td>
          </tr>

          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">รวมรับเงินทั้งสิ้น</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ (parseFloat( total_sum.total_etc) +parseFloat(  total_sum.total_credit )+ parseFloat( total_sum.total_qr) + parseFloat( total_sum.total_payment) + parseFloat( total_sum.total_cash)).toFixed(2)}}</p>
            </td>
          </tr>

          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">จำนวนใบเสร็จมีภาษี</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ total_sum.count_without_vat }}</p>
            </td>
          </tr>

          <tr>
            <td colspan="4">
              <div class="color-gray font-11"> - - - - - - - - - - - - - - - - - - - - - - - - - -</div>
            </td>
          </tr>

          <tr>
            <td colspan="4">
              <h1 class="font-13 fw-600" style="margin-left: 13px;">สรุปการรับเงินจากการขาย / มีภาษี :</h1>
            </td>
          </tr>

          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">เงินสด</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              {{  }}
              <p class="mt-5 font-10">{{ total_sum.total_cash_vat }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">เงินโอน</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ total_sum.total_payment_vat }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">qr payment</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ total_sum.total_qr_vat }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">เครดิตการ์ด</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ total_sum.total_credit_vat }}</p>
            </td>
          </tr>
          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">อื่นๆ</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ total_sum.total_etc_vat }}</p>
            </td>
          </tr>

          <tr>
            <td colspan="4">
              <hr style="border-top: #D9D9D9; margin: 5px 0;" />
            </td>
          </tr>

          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">รวมรับเงินทั้งสิ้น</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{(parseFloat( total_sum.total_etc_vat) + parseFloat( total_sum.total_credit_vat) + parseFloat( total_sum.total_qr_vat) + parseFloat( total_sum.total_payment_vat )+ parseFloat( total_sum.total_cash_vat)).toFixed(2)}}</p>
            </td>
          </tr>

          <tr class="tabletitle">
            <td>
              <p class="mt-5 font-10">จำนวนใบเสร็จไม่มีภาษี</p>
            </td>
            <td></td>
            <td></td>
            <td class="text-right">
              <p class="mt-5 font-10">{{ total_sum.count_with_vat }}</p>
            </td>
          </tr>

        </table>
      </div><!--End Table-->

      <div id="legalcopy">
        <p class="font-13 fw-500">แคชเชียร์ : {{ get_data.user_edit }}</p>
      </div>
    </div><!--End InvoiceBot-->
  </div><!--End Invoice-->
</template>

<script>
import img_arin from "@/assets/arin_assets/pharmacare-black.png";
import { HTTP_ARIN } from "@/axios_arin";
import { formatPrice } from "@/js/handler";
export default {
  data() {
    return {
      round_print_type: 0,
      img_arin: img_arin,
      items: [
        { name: "tab.CARATEN 12.5 MG. ...", sale: "ส่วนลด NODOGLE SPRAY ", quantity: 5, subTotal: 375, slae_cost: 80 },
        // { name: "eent.NODOGLE SPRAY   ...",sale: null, quantity: 3, subTotal: 225 , slae_cost: 0},
        // { name: "ยาดม IZE JELLI BALM 7  ...",sale: null, quantity: 5, subTotal: 375 , slae_cost: 0},
        // { name: "cr.DELANIN CREAM 5G ...",sale: null, quantity: 20, subTotal: 1500 , slae_cost: 0},

      ],
      value: 295,
      sale_sum: 20,
      tax: 19.25,
      credit: 8.83,
      total: 303.08,
      cash: 310.00,
      change: 6.92,
      get_data: {},
      total_qty: 0,
      total_price: 0,
      seller: {},
      loading_page: true,
      vowelCharacters: "aeiouAEIOUะัาำิีึื็ุู่้๊๋์ํๆ",
      total_sum: {
        total_cash: 0,
        total_payment: 0,
        total_credit: 0,
        total_etc: 0,
        total_cash_vat: 0,
        total_payment_vat: 0,
        total_credit_vat: 0,
        total_etc_vat: 0,
        count_with_vat:0,
        count_without_vat:0
      },
    };
  },
  methods: {
    formatPrice(value) {
      return formatPrice(value);
    },
    formatDate(dateStr) {
      if (!dateStr) return "";
      const dt = new Date(dateStr);
      const padL = (nr) => `${nr}`.padStart(2, '0');
      return `${padL(dt.getDate())}/${padL(dt.getMonth() + 1)}/${dt.getFullYear()} ${padL(dt.getHours())}:${padL(dt.getMinutes())}:${padL(dt.getSeconds())}`;
    },

    formatTime(dateStr) {
      if (!dateStr) return ""; // ถ้าไม่มีค่า ให้แสดง "N/A"
      const dt = new Date(dateStr);
      const padL = (nr) => `${nr}`.padStart(2, '0');
      return `${padL(dt.getHours())}:${padL(dt.getMinutes())}`; // แสดงเฉพาะ HH:mm
    },

    async print() {
      document.getElementById("invoice-POS").innerHTML;
      // document.body.innerHTML = printContents;
      const originalContents = document.body.innerHTML;
      window.print();


      window.onafterprint = function () {
        document.body.innerHTML = originalContents;
        window.close();
      };
    },

    // api/pos/report/round/print
    async getRoundPrint() {
      this.loading_page = true;
      let config = {
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
        }
      }
      let id = parseInt(this.$route.query.id);
      let round_print_type = parseInt(this.$route.query.type);

      // ดึงทั้งหมด
      if(round_print_type == 0){
        await HTTP_ARIN.post(`/pos/report/round/print/pdf`,{id: id, type: round_print_type}, config).then((res) => {
          if (res.data.successful === true) {
            this.get_data = res.data.data
            this.loading_page = false;
          }
        })
      }else if(round_print_type == 1){
        let invoice_id =JSON.parse( window.localStorage.getItem("sum_data"));
        await HTTP_ARIN.post(`/pos/report/round/print/pdf`,{id: id, type: round_print_type, invoice_id: invoice_id}, config).then((res) => {
          if (res.data.successful === true) {
            this.get_data = res.data.data
            this.loading_page = false;
          }
        })
      }

    },
    // async getReceipt() {
    //   this.loading_page = true;
    //   let config = {
    //     headers: {
    //       'Content-Type': 'application/json',
    //       "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
    //     }
    //   }
    //   let id = this.$route.query.id
    //   await HTTP_ARIN.get(`/pos/invoice/detail/${id}`, config).then((res) => {
    //     if (res.data.successful === true) {
    //       this.detailList = res.data.data
    //       this.detailList.invoice_list.forEach((detail) => {
    //         if (detail.product_code != null) {
    //           this.total_qty += parseFloat(detail.qty)
    //           this.total_price += parseFloat(detail.total)
    //         } else {
    //           this.total_price -= parseFloat(detail.total)
    //         }
    //       })
    //       this.loading_page = false;
    //       this.getSotre()
    //     }
    //   })
    // },
     async getSotre() {
      let config = {
        headers: {
           'Content-Type': 'application/json',
          "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
         }
       }
       let store_id = this.$store.state.store_arin.user_data.store_id;
       await HTTP_ARIN.get('/stores/detail/' + store_id, config).then((res) => {
         if (res.data.successful === true) {
           this.seller = res.data.storeDetail;
         }
       })
       this.print()
     },

    async closeStore() {
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      let id = parseInt(this.$route.query.id)
      await HTTP_ARIN.get(`/pos/round/sum/${id}`, config).then((res) => {
        if (res.data.successful === true) {
          
          this.total_sum.total_cash = res.data.sumResult.total_cash;
          this.total_sum.total_payment = res.data.sumResult.total_payment;
          this.total_sum.total_credit = res.data.sumResult.total_credit;
          this.total_sum.total_etc = res.data.sumResult.total_etc;
          this.total_sum.total_cash_vat = res.data.sumResult.total_cash_vat;
          this.total_sum.total_payment_vat = res.data.sumResult.total_payment_vat;
          this.total_sum.total_qr = res.data.sumResult.total_qr;
          this.total_sum.total_qr_vat = res.data.sumResult.total_qr_vat;
          this.total_sum.total_credit_vat = res.data.sumResult.total_credit_vat;
          this.total_sum.total_etc_vat = res.data.sumResult.total_etc_vat;
          this.total_sum.count_with_vat = res.data.sumResult.count_with_vat;
          this.total_sum.count_without_vat = res.data.sumResult.count_without_vat;
        }
      });
    },
  },
  mounted() {
    // this.getReceipt()
    this.getSotre();
    this.closeStore()
    this.getRoundPrint()
  },
};
</script>

<style scoped>
.fw-500 {
  font-weight: 500;
}

.fw-600 {
  font-weight: 600;
}

.font-8 {
  font-size: 8px;
}

.font-10 {
  font-size: 10px;
}

.font-11 {
  font-size: 11px;
}

.font-12 {
  font-size: 11.5px;
}

.font-13 {
  font-size: 11.5px;
}

.font-14 {
  font-size: 14px;
}

.font-16 {
  font-size: 16px;
}

#invoice-POS {
  box-shadow: 0 0 1in -0.25in rgba(0, 0, 0, 0.5);
  padding: 2mm;
  margin: 0 auto;
  width: 58mm;
  background: #FFF;
}

::selection {
  background: #f31544;
  color: #FFF;
}

::moz-selection {
  background: #f31544;
  color: #FFF;
}

h1 {
  font-size: 1.5em;
  color: #000000;
}

h2 {
  font-size: 0.9em;
}

h3 {
  font-size: 1.2em;
  font-weight: 300;
  line-height: 2em;
}

p {
  font-size: 1em;
  color: #000000;
  line-height: 1.2em;
}

#top,
#mid,
#bot {
  /* Targets all id with 'col-' */
  border-bottom: 1px solid #EEE;
}

#top {
  min-height: 50px;
}

#mid {
  min-height: 80px;
}

#bot {
  min-height: 50px;
}

#top .logo {
  /*float: left;*/
  /* height: 60px; */
  width: 150px;
  /* background: url('img_arin') no-repeat; */
  background-size: 60px 60px;
}

.clientlogo {
  float: left;
  height: 60px;
  width: 60px;
  background: url(http://michaeltruong.ca/images/client.jpg) no-repeat;
  background-size: 60px 60px;
  border-radius: 50px;
}

.info {
  display: block;
  /*float:left;*/
  margin-left: 0;
}

.title {
  float: right;
}

.title p {
  text-align: right;
}

table {
  width: 100%;
  border-collapse: collapse;
}

td p {
  font-size: 0.9em;
  /*padding: 5px 0 5px 15px;*/
  /*border: 1px solid #EEE*/
}

.tabletitle {
  /*padding: 5px;*/
  font-size: 0.6em;
  /* background: #EEE; */
}

.service {
  border-bottom: 0px solid #EEE;
}

.item {
  width: 40mm;
}

.item-med {
  width: 15mm;
}

.itemtext {
  font-size: 0.9em;
}

.Rate {
  font-size: 0.9em;
}

.payment {
  font-size: 1.2em;
}

#legalcopy {
  margin-top: 7mm;
  margin-bottom: 7mm;
}

.flex-center {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.pr-5 {
  padding-right: 5px;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.w-100 {
  width: 100%;
}

.color-gray {
  color: #000000;
}

.color-gray-mid {
  color: #000000;
}

.va-top {
  vertical-align: top;
}

.mt-10 {
  margin-top: 10px;
}

.mt-5 {
  margin-top: 3px;
}

.mt-4 {
  margin-top: 4px;
}
</style>


